import React from "react";

import IntroInfoItem from "../../../components/IntroInfoItem";

import "./intro.css";

import cvImg from "../../../assets/img/vahid-ghodsi-s.jpg";

const cvSectionIntro = (props) => {
  return (
    <section className="Intro-sec Sec" id={props.id}>
      <div className="Sec__spacer"></div>
      <div className="Sec__container">
        <div className="intro__content">
          <div className="intro-content__text">
            <div className="Prefix-sign"> {">"} </div>
            <div className="content-text">
              Acting as founder/principal architect in method Architects, I have been actively involved in all
              different stages of the architecture profession since my graduation form TU Delft in 2013. My professional
              experience ranges from cooperating with a number of renowned offices, to running the whole process of
              designing, managing and delivering projects. These projects include interiors, private and shared
              residential buildings, office buildings, a head office complex and competitions. 
            </div>
              {/* As outside interests, I do web and graphic design, play the guitar, do sports, and I am always excited to read and hear about
              variety of subjects. */}
          </div>
          <ul className="intro-content__info">
            <IntroInfoItem title={"Birth Info."}> 21/02/1986 - Tehran,&nbsp;Iran </IntroInfoItem>
            <IntroInfoItem title={"Tel No."}> +49&#8209;1520&#8209;2742152 | +98&#8209;912&#8209;2117330 </IntroInfoItem>
            <IntroInfoItem title={"E-mail"}> v.ghodsii@gmail.com </IntroInfoItem>
            <IntroInfoItem title={"Website"}>
              <a href="http://www.vahidghodsi.com">www.vahidghodsi.com</a> |{" "}
              <a href="http://www.method.ir">www.method.ir</a>{" "}
            </IntroInfoItem>
            <IntroInfoItem title={"Address"}>
              &nbsp;Driesener straße&nbsp;8B,
              10439,&nbsp;Berlin{" "}
            </IntroInfoItem>
            {/* <IntroInfoItem title={"Address"}>
              &nbsp;Unit&nbsp;602, No.&nbsp;20, Aliakbar&nbsp;(12st)&nbsp;st., Kaj&nbsp;sq., Saadat&nbsp;abad,
              Tehran,&nbsp;Iran{" "}
            </IntroInfoItem> */}
          </ul>
        </div>
        <div className="intro__pic">
          <img src={cvImg} alt="vahid ghodsi" />
        </div>
      </div>
      <div className="Sec__spacer-end"></div>
    </section>
  );
};

export default cvSectionIntro;
